import * as fromDatatype from "../datatype-library/index";

export interface alg_bot_cf_conversation_instance_events_RowInterface
{
	guid: fromDatatype.GuidDataFieldInterface;
	element_guid: fromDatatype.GuidDataFieldInterface;
	message_guid: fromDatatype.GuidDataFieldInterface;
	conversation_instance_guid: fromDatatype.GuidDataFieldInterface;
	code: fromDatatype.VarcharDatatypeInterface;
	name: fromDatatype.VarcharDatatypeInterface;
	description: fromDatatype.TextDatatypeInterface;
  event_source: fromDatatype.GuidDataFieldInterface;
	applet_guid: fromDatatype.GuidDataFieldInterface;
	module_guid: fromDatatype.GuidDataFieldInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	revision: fromDatatype.RevisionDataFieldInterface;
	vrsn: fromDatatype.VrsnDataFieldInterface;
	status: fromDatatype.StatusDataFieldInterface;
	property_json: fromDatatype.JsonDatatypeInterface;
	acl_config: fromDatatype.JsonDatatypeInterface;
	acl_policy: fromDatatype.JsonDatatypeInterface;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
	updated_date: fromDatatype.TimestampTzDatatypeInterface;
}

export class alg_bot_cf_conversation_instance_events_RowClass implements alg_bot_cf_conversation_instance_events_RowInterface
{
	guid: fromDatatype.GuidDataFieldInterface;
	element_guid: fromDatatype.GuidDataFieldInterface;
	message_guid: fromDatatype.GuidDataFieldInterface;
	conversation_instance_guid: fromDatatype.GuidDataFieldInterface;
	code: fromDatatype.VarcharDatatypeInterface;
	name: fromDatatype.VarcharDatatypeInterface;
	description: fromDatatype.TextDatatypeInterface;
  event_source: fromDatatype.GuidDataFieldInterface;
	applet_guid: fromDatatype.GuidDataFieldInterface;
	module_guid: fromDatatype.GuidDataFieldInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	revision: fromDatatype.RevisionDataFieldInterface;
	vrsn: fromDatatype.VrsnDataFieldInterface;
	status: fromDatatype.StatusDataFieldInterface;
	property_json: fromDatatype.JsonDatatypeInterface;
	acl_config: fromDatatype.JsonDatatypeInterface;
	acl_policy: fromDatatype.JsonDatatypeInterface;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
	updated_date: fromDatatype.TimestampTzDatatypeInterface;
}
